import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
const MOBILE_BREAKPOINT = 500;
const useIsMobile = () => {
  const $ = _c(5);
  const [isMobile, setIsMobile] = useState(undefined);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const update = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
      update();
      window.addEventListener("resize", update);
      return () => window.removeEventListener("resize", update);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const t2 = isMobile === undefined;
  const t3 = !!isMobile;
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = {
      isLoading: t2,
      isMobile: t3
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export { useIsMobile };